import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { currentProjectIdSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { styleSelected } from '@chegg-wt/core/state/currentProject/actions'

type QueryParams = {
  newStyle?: string
}

const useQueryStringStyleUpdate = (): void => {
  const router = useRouter()
  const stateCurrentProjectId = useSelector(currentProjectIdSelector)
  const dispatch = useDispatch()

  const { newStyle } = router.query as QueryParams

  useEffect(() => {
    if (newStyle && stateCurrentProjectId) {
      // isStyleGateFlagEnabled flag is not needed here since this hook is not used on style pages for CTFM/BM
      dispatch(styleSelected(newStyle, true))
    }
  }, [newStyle, stateCurrentProjectId, dispatch])
}

export default useQueryStringStyleUpdate
